module.exports = __webpack_public_path__ + "static/media/post-btn.467d63a4.svg";